export default "__VITE_ASSET__BqS8cgcx__"